/**
 * Project : workspace
 * File    : Localization.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package locale

import com.parmartechnologies.communication.core.handler.AuthHandler
import com.parmartechnologies.core.feature.locale.Localization

/**
 * Executes the localization operation.
 *
 * @receiver TODO
 * @return The resulting localization.
 */

fun localization(): Localization {
    return AuthHandler.shared().repository.localization.value
}